import ContentWrapper from "@/components/wrappers/ContentWrapper";
import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useGetCalcSettingsDetail } from "../../../../common/api/queries/calcSettings";
import BackNavigationArrow from "../../../../common/components/views/BackNavigationArrow";
import { EntityIdObject } from "../../../../common/types";
import { UpdateCalcSettingsForm } from "../components/forms/UpdateCalcSettingsForm";

export const CalcSettingsDetailContainer = () => {
  const { t } = useTranslation();

  const { id } = useParams<EntityIdObject>() as { id: string };

  const { data: calcSettings, isError } = useGetCalcSettingsDetail(id);

  return (
    <ContentWrapper>
      <DisplayWrapper itemLoaded={!!calcSettings} isError={isError}>
        {calcSettings ? (
          <Card
            className="card-box"
            title={
              <BackNavigationArrow>
                <h2>
                  {t("calc.settings.titles.settings", {
                    calcType: t("calc.enums.calcType." + calcSettings.type),
                    institution: calcSettings.institution.name,
                  })}
                </h2>
              </BackNavigationArrow>
            }
          >
            <UpdateCalcSettingsForm calcType={calcSettings.type} calcSettings={calcSettings} />
          </Card>
        ) : undefined}
      </DisplayWrapper>
    </ContentWrapper>
  );
};
